import { RadioGroupField } from 'lib/iterable-hook-form';
import styled from 'styled-components';
import {
  body2,
  body2Medium,
  borderColors,
  borderRadius,
  caption,
  colors,
  overline,
  spacing,
  subtitle2,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';

/** Hold Until Reply */
export const StyledRadioGroupField = styled(RadioGroupField)`
    width: 100%;
    gap: ${pxToRem(16)};
    padding: ${spacing.half};

    div {
        padding: ${spacing.half};   
    }

    > div[data-disabled="true"] {
        background-color: ${colors.grey1};
    }

    > div[data-disabled="true"]:has(button[aria-checked="true"]) {
        background-color: ${colors.grey10};
    }
`;

export const HoldUntilReplyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: ${pxToRem(24)};
    flex-shrink: 0;
`;

export const BorderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing.half};
    align-self: stretch;
    padding: ${pxToRem(16)};
    width: 100%;

    border-radius: ${borderRadius.xl};
    border: 1px solid ${borderColors.borderPrimary};
    background: ${colors.backgroundSecondary};
`;

export const RadioLabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const RadioLabelText = styled.span`
    ${body2};
    text-align: center;
`;

/** Replies */

export const RepliesContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing.half};
    align-self: stretch;
`;

export const ReplyHeaderContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: ${pxToRem(28)};
    padding-right: ${spacing.half};
    align-items: center;
    gap: ${spacing.base};
    align-self: stretch;
`;

export const ReplyHeaderTextContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${spacing.base};
`;

export const HoldDurationContainer = RepliesContainer;

export const ReplyHeaderText = styled.span`
    color: ${colors.secondaryText};
    ${overline};
`;

export const RepliesLabel = styled.label`
    color: ${colors.textPrimary};
    ${subtitle2};
`;

export const VariantContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing.base};
    align-self: stretch;
`;

export const VariantsList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing.half};
    align-self: stretch;
`;

export const DropReplyHereContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: stretch;
`;
export const DropReplyHereText = styled.span`
color: ${colors.textSecondary};
font-size: ${pxToRem(14)};
font-style: normal;
font-weight: 500;
line-height: ${pxToRem(20)}; /* 142.857% */
`;

export const VariantRow = styled.div`
    display: flex;
    gap: ${spacing.base};
    align-items: center;
    width: 100%;
`;

export const Pill = styled.div`
    display: flex;
    padding: ${spacing.quarter} ${spacing.half};
    align-items: center;
    gap: ${spacing.half};
    border-radius: ${borderRadius.md};
    border: 1px solid ${borderColors.borderPrimary};
    background: ${colors.backgroundDisabled};
    ${body2};
    color: ${colors.textSecondary};
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const RemoveContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

export const AddVariationButtonText = styled.span`
    color: ${colors.textSecondary};
    font-weight: 500;
`;

/** Add New Reply */
export const AddNewReplySectionButtonText = styled.span`
    font-weight: 500;
`;

export const UnknownReplyCheckBoxContainer = styled.div`
    display: flex;
    align-items: baseline;
    gap: ${spacing.half};
`;

export const CheckboxDescription = styled.span`
    display: flex;
    flex-direction: column;
    gap: ${spacing.half};
    ${body2Medium};
`;

export const Caption = styled.span`
    ${caption}
    color: ${colors.textSecondary};
`;

export const FormFieldLabel = styled.span`
    ${subtitle2};
    color: ${colors.textPrimary};
`;

export const FormFieldDescription = styled.label`
    ${body2};
    color: ${colors.textSecondary};`;

export const CustomDurationContainer = styled.div`
    display: flex;
    gap: ${spacing.base};
    width: 100%;
`;
